import { Item } from '../types/Item';

export const items: Item[] = [
  { date: new Date(2023, 3, 1), category: 'food', title: 'McDonalds', value: 32.12 },
  { date: new Date(2023, 3, 1), category: 'food', title: 'Burguer King', value: 28 },
  { date: new Date(2023, 2, 16), category: 'rent', title: 'House', value: 2300 },
  { date: new Date(2023, 2, 5), category: 'salary', title: 'Salary', value: 4500 },
];